import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e09fb0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting-users bg-white relative" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buttons-section sticky top-0 bg-white z-20" }, null, -1))
const _hoisted_4 = { class: "title-section sticky top-0 bg-white z-20 flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-row flex-grow" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold block text-left pb-4" }, "Utenti")
], -1))
const _hoisted_6 = { class: "button-row pb-8" }
const _hoisted_7 = { class: "searchbar flex" }
const _hoisted_8 = { class: "list h-full overflow-auto" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"titles grid grid-cols-6 bg-primary-50\" data-v-7e09fb0a><div class=\"title name\" data-v-7e09fb0a>Nome</div><div class=\"title role\" data-v-7e09fb0a>Ruolo</div><div class=\"title email\" data-v-7e09fb0a>Email</div><div class=\"title phone\" data-v-7e09fb0a>Telefono</div><div class=\"title status\" data-v-7e09fb0a>Stato</div><div class=\"title actions\" data-v-7e09fb0a>Azioni</div></div>", 1)
const _hoisted_10 = { class: "users overflow-y-scroll" }
const _hoisted_11 = { class: "user grid grid-cols-6" }
const _hoisted_12 = { class: "name my-auto text-left" }
const _hoisted_13 = { class: "role my-auto" }
const _hoisted_14 = { class: "email my-auto text-left" }
const _hoisted_15 = { class: "phone my-auto" }
const _hoisted_16 = {
  key: 0,
  class: "status my-auto grid grid-cols-2"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "m-auto",
  width: "11",
  height: "10",
  viewBox: "0 0 11 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "5.42578",
    cy: "5",
    r: "5",
    fill: "#00A98A"
  })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-auto" }, "Abilitato", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "status my-auto grid grid-cols-2"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "m-auto",
  width: "11",
  height: "10",
  viewBox: "0 0 11 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "5.42578",
    cy: "5",
    r: "5",
    fill: "#FC0F0F"
  })
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-auto" }, "Disabilitato", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "actions my-auto" }
const _hoisted_25 = { class: "grid grid-cols-3 bg-primary-50 m-auto icons-group" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "m-auto",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.4258 2H8.42578C5.11678 2 2.42578 4.691 2.42578 8V21C2.42578 21.2652 2.53114 21.5196 2.71867 21.7071C2.90621 21.8946 3.16056 22 3.42578 22H16.4258C19.7348 22 22.4258 19.309 22.4258 16V8C22.4258 4.691 19.7348 2 16.4258 2ZM20.4258 16C20.4258 18.206 18.6318 20 16.4258 20H4.42578V8C4.42578 5.794 6.21978 4 8.42578 4H16.4258C18.6318 4 20.4258 5.794 20.4258 8V16Z",
    fill: "#2650A0"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.42578 14.9868V16.9858H9.42478L14.9538 11.4638L12.9558 9.46582L7.42578 14.9868Z",
    fill: "#2650A0"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.8959 10.522L13.8979 8.522L15.4209 7L17.4209 8.999L15.8959 10.522Z",
    fill: "#2650A0"
  })
], -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "m-auto",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.9258 6C21.9257 6.24493 21.8358 6.48134 21.6731 6.66437C21.5103 6.84741 21.286 6.96434 21.0428 6.993L20.9258 7H20.0808L18.8498 19.52C18.7828 20.1994 18.4655 20.8295 17.9596 21.2879C17.4537 21.7462 16.7954 22.0001 16.1128 22H8.73878C8.05613 22.0001 7.39785 21.7462 6.89198 21.2879C6.38611 20.8295 6.06881 20.1994 6.00178 19.52L4.77078 7H3.92578C3.66056 7 3.40621 6.89464 3.21867 6.70711C3.03114 6.51957 2.92578 6.26522 2.92578 6C2.92578 5.73478 3.03114 5.48043 3.21867 5.29289C3.40621 5.10536 3.66056 5 3.92578 5H8.92578C8.92578 4.54037 9.01631 4.08525 9.1922 3.66061C9.36809 3.23597 9.6259 2.85013 9.95091 2.52513C10.2759 2.20012 10.6617 1.94231 11.0864 1.76642C11.511 1.59053 11.9662 1.5 12.4258 1.5C12.8854 1.5 13.3405 1.59053 13.7652 1.76642C14.1898 1.94231 14.5756 2.20012 14.9007 2.52513C15.2257 2.85013 15.4835 3.23597 15.6594 3.66061C15.8353 4.08525 15.9258 4.54037 15.9258 5H20.9258C21.191 5 21.4454 5.10536 21.6329 5.29289C21.8204 5.48043 21.9258 5.73478 21.9258 6ZM14.6758 9.25C14.4945 9.25001 14.3194 9.31564 14.1829 9.43477C14.0463 9.55389 13.9574 9.71845 13.9328 9.898L13.9258 10V17L13.9328 17.102C13.9575 17.2815 14.0463 17.446 14.1829 17.5651C14.3195 17.6842 14.4946 17.7498 14.6758 17.7498C14.857 17.7498 15.0321 17.6842 15.1686 17.5651C15.3052 17.446 15.3941 17.2815 15.4188 17.102L15.4258 17V10L15.4188 9.898C15.3941 9.71845 15.3053 9.55389 15.1687 9.43477C15.0321 9.31564 14.857 9.25001 14.6758 9.25ZM10.1758 9.25C9.99454 9.25001 9.81944 9.31564 9.68285 9.43477C9.54626 9.55389 9.45743 9.71845 9.43278 9.898L9.42578 10V17L9.43278 17.102C9.45748 17.2815 9.54634 17.446 9.68292 17.5651C9.8195 17.6842 9.99458 17.7498 10.1758 17.7498C10.357 17.7498 10.5321 17.6842 10.6686 17.5651C10.8052 17.446 10.8941 17.2815 10.9188 17.102L10.9258 17V10L10.9188 9.898C10.8941 9.71845 10.8053 9.55389 10.6687 9.43477C10.5321 9.31564 10.357 9.25001 10.1758 9.25ZM12.4258 3.5C12.028 3.5 11.6464 3.65804 11.3651 3.93934C11.0838 4.22064 10.9258 4.60218 10.9258 5H13.9258C13.9258 4.60218 13.7677 4.22064 13.4864 3.93934C13.2051 3.65804 12.8236 3.5 12.4258 3.5Z",
    fill: "#2650A0"
  })
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "m-auto",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.4258 1.5C6.62734 1.5 1.92578 6.20156 1.92578 12C1.92578 17.7984 6.62734 22.5 12.4258 22.5C18.2242 22.5 22.9258 17.7984 22.9258 12C22.9258 6.20156 18.2242 1.5 12.4258 1.5ZM12.4258 20.7188C7.61172 20.7188 3.70703 16.8141 3.70703 12C3.70703 7.18594 7.61172 3.28125 12.4258 3.28125C17.2398 3.28125 21.1445 7.18594 21.1445 12C21.1445 16.8141 17.2398 20.7188 12.4258 20.7188Z",
    fill: "#2650A0"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.3008 7.875C11.3008 8.17337 11.4193 8.45952 11.6303 8.6705C11.8413 8.88147 12.1274 9 12.4258 9C12.7241 9 13.0103 8.88147 13.2213 8.6705C13.4323 8.45952 13.5508 8.17337 13.5508 7.875C13.5508 7.57663 13.4323 7.29048 13.2213 7.0795C13.0103 6.86853 12.7241 6.75 12.4258 6.75C12.1274 6.75 11.8413 6.86853 11.6303 7.0795C11.4193 7.29048 11.3008 7.57663 11.3008 7.875ZM12.9883 10.5H11.8633C11.7602 10.5 11.6758 10.5844 11.6758 10.6875V17.0625C11.6758 17.1656 11.7602 17.25 11.8633 17.25H12.9883C13.0914 17.25 13.1758 17.1656 13.1758 17.0625V10.6875C13.1758 10.5844 13.0914 10.5 12.9883 10.5Z",
    fill: "#2650A0"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EditUserModalDialog = _resolveComponent("EditUserModalDialog")!
  const _component_ArchivieUserDocument = _resolveComponent("ArchivieUserDocument")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_SecondaryButton, {
              class: "archive-tool text-white bg-primary-900 block float-right",
              onClick: _ctx.showAddNewUserDialog
            }, {
              default: _withCtx(() => [
                _createTextVNode("Aggiungi")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            class: "text px-4 py-3 flex-grow bg-gray-100 text-black",
            type: "text",
            placeholder: "Cerca utente...",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.search()), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _createVNode(_component_PrimaryButton, {
            class: "button bg-gray-100 text-black flex-none",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cerca")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(user.name) + " " + _toDisplayString(user.surname), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.parseUserRole(user.role)), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(user.email), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(user.phone), 1),
                (user.isEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      class: "edit pl-1 pr-1",
                      onClick: ($event: any) => (_ctx.onEditUser(user))
                    }, _hoisted_28, 8, _hoisted_26),
                    _createElementVNode("button", {
                      class: "remove pl-1 pr-1",
                      onClick: ($event: any) => (_ctx.onRemoveUser(user))
                    }, _hoisted_31, 8, _hoisted_29),
                    _createVNode(_component_router_link, {
                      class: "bg-primary text-white w-full text-left align-middle info flex pl-1 pr-1 focus:outline-none focus:shadow-outline",
                      type: "button",
                      to: `/reports/${user.id}`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ])
              ]))
            }), 256))
          ])
        ])
      ]),
      (_ctx.userDialogIsPresented)
        ? (_openBlock(), _createBlock(_component_EditUserModalDialog, {
            key: 0,
            onClose: _ctx.hideUserDialog,
            mode: _ctx.userDialogMode,
            "model-value": _ctx.userDialogUser
          }, null, 8, ["onClose", "mode", "model-value"]))
        : _createCommentVNode("", true),
      (_ctx.userArchiveDialogIsPresented)
        ? (_openBlock(), _createBlock(_component_ArchivieUserDocument, {
            key: 1,
            onClose: _ctx.hideRemoveUserDialog,
            "model-value": _ctx.userDialogUser
          }, null, 8, ["onClose", "model-value"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Creazione..."
        }))
      : _createCommentVNode("", true)
  ], 64))
}